import React, { useState } from 'react'
import { Button, Modal, Tag, Alert, Tooltip } from 'antd'
import { MailOutlined, LinkOutlined } from '@ant-design/icons'
import { apiRequest } from '../../helpers'
import { useNavigate } from 'react-router-dom'

const apiUrl = process.env.REACT_APP_API

const EmailSourceButton = ({ emailMessageId }) => {
  const [email, setEmail] = useState(null)
  const [loading, setLoading] = useState(false)
  const [modalOpen, setModalOpen] = useState(false)
  const navigate = useNavigate()

  const handleClick = async (e) => {
    e.stopPropagation()
    setModalOpen(true)
    if (email) return
    setLoading(true)
    try {
      const res = await apiRequest(`${apiUrl}emails/${emailMessageId}`, 'GET')
      if (res?.data) setEmail(res.data)
    } catch (e) {
      console.error('Error fetching email:', e)
    } finally {
      setLoading(false)
    }
  }

  const handleOpenInbox = () => {
    setModalOpen(false)
    navigate(`/emails?id=${emailMessageId}`)
  }

  if (!emailMessageId) return <span style={{ color: '#aaa' }}>—</span>

  return (
    <>
      <Tooltip title="Vezi emailul sursa">
        <Button size="small" icon={<MailOutlined />} onClick={handleClick}>
          #{emailMessageId}
        </Button>
      </Tooltip>

      <Modal
        title="Email sursa"
        open={modalOpen}
        onCancel={() => setModalOpen(false)}
        width={700}
        footer={[
          <Button key="close" onClick={() => setModalOpen(false)}>Inchide</Button>,
          email && (
            <Button key="inbox" type="primary" icon={<LinkOutlined />} onClick={handleOpenInbox}>
              Deschide in Inbox
            </Button>
          ),
        ].filter(Boolean)}
      >
        {loading && <p style={{ color: '#888' }}>Se incarca...</p>}
        {!loading && email && (
          <>
            <div style={{ background: '#f5f5f5', borderRadius: 6, padding: 12, marginBottom: 16 }}>
              <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr', gap: 8 }}>
                <span style={{ fontWeight: 600 }}>ID:</span>
                <code>#{email.id}</code>
                <span style={{ fontWeight: 600 }}>De la:</span>
                <span>{email.from || '—'}</span>
                <span style={{ fontWeight: 600 }}>Subiect:</span>
                <span>{email.subject || '—'}</span>
                <span style={{ fontWeight: 600 }}>Data:</span>
                <span>{email.receivedAt ? new Date(email.receivedAt).toLocaleString('ro-RO') : '—'}</span>
                <span style={{ fontWeight: 600 }}>Status:</span>
                <Tag color={email.status === 'processed' ? 'green' : 'default'}>{email.status}</Tag>
              </div>
            </div>
            <div style={{ fontWeight: 600, marginBottom: 8 }}>Continut email:</div>
            <div style={{ maxHeight: 300, overflowY: 'auto', whiteSpace: 'pre-wrap', fontSize: 13, background: '#fafafa', padding: 12, borderRadius: 6 }}>
              {email.body || email.bodyHtml || '(fara continut)'}
            </div>
          </>
        )}
        {!loading && !email && (
          <Alert message="Nu s-a putut incarca emailul sursa." type="warning" showIcon />
        )}
      </Modal>
    </>
  )
}

export default EmailSourceButton
